import React from "react";
import { AppProviders } from "@/app/providers/app-providers";
import { AppRouter } from "@/app/router/app-router";

/** Root composition boundary: global providers wrap the route tree here. */
export function App() {
    return <AppProviders><AppRouter /></AppProviders>;
}
